export function generateReferralActivationInfoPrintContent({
  activationCode,
  appUrl,
  courseTitle,
  formattedDate,
  formattedTime,
  pngImage,
}: {
  activationCode: string;
  appUrl: string;
  courseTitle: string;
  formattedDate: string;
  formattedTime: string;
  pngImage: string;
}): string {
  return `<html>
  <head>
    <title>Referral Activation Information - ${formattedDate} ${formattedTime}</title>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
      rel="stylesheet"
    />

    <style>
      @media print {
        @page {
          size: A4;
          margin: 0;
        }

        @font-face {
          font-family: 'Inter';
          src: url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
        }

        body {
          margin: 0;
          padding: 0;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          width: 100%;
          height: 100%;
          font-family: 'Inter', sans-serif;
        }

        header,
        footer {
          display: none;
        }
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      div,
      body {
        margin: 0;
        padding: 0;
      }

      body {
        font-family: 'Inter', sans-serif;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
      }
    </style>
  </head>

  <body>
    <div
      style="
        display: flex;
        padding: 32px 100px;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        width: 395px;
      "
    >
      <div
        style="
          display: flex;
          padding: 13.335px 16.002px;
          flex-direction: column;
          align-items: center;
          gap: 6.668px;
          align-self: stretch;
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="97"
          height="33"
          viewBox="0 0 97 33"
          fill="none"
        >
          <path
            d="M85.7677 32.3632C78.75 32.3632 74.2329 27.3981 74.2329 21.0604C74.2329 14.7227 79.1533 9.67676 85.6467 9.67676C92.1803 9.67676 96.8991 14.3997 96.8991 20.8585V22.9576H79.597C80.3229 25.7834 82.6218 27.5595 85.8483 27.5595C87.917 27.5595 89.4417 26.8335 90.5262 25.6309C91.6328 26.3333 93.5646 27.5595 94.9367 28.4305C92.8267 30.8553 89.9582 32.3632 85.7677 32.3632ZM85.6467 14.3997C82.8235 14.3997 80.6456 16.0548 79.7583 18.598H91.3737C90.6478 15.8933 88.5505 14.3997 85.6467 14.3997Z"
            fill="#171923"
          />
          <path
            d="M67.9677 31.6959L61.8209 22.7266L58.4864 26.4672V31.6959H52.9824V0.335205H58.4864V20.072L67.2847 9.97645H73.9136L65.758 19.2273L74.3153 31.6959H67.9677Z"
            fill="#171923"
          />
          <path
            d="M38.6326 32.3646C31.6344 32.3646 27.9854 27.934 27.9854 20.5361V10.0117H33.8104V20.6581C33.8104 24.3163 35.1537 26.8365 38.6326 26.8365C42.1114 26.8365 42.8265 24.3163 42.8265 20.6581V10.0117H48.6516V20.5361C48.6516 27.934 45.6307 32.3646 38.6326 32.3646Z"
            fill="#171923"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.1268 20.7092C23.1296 20.8124 23.1309 20.916 23.1309 21.0199C23.1309 27.277 18.17 32.3634 11.5958 32.3634C5.06197 32.3634 0.101074 27.277 0.101074 21.0199C0.101074 14.7224 5.06197 9.67629 11.5958 9.67629C13.8533 9.67629 15.9353 10.2862 17.691 11.3465V0.335449H23.1309V20.7074C23.1309 20.7074 23.1295 20.708 23.1268 20.7092ZM17.6054 20.9795C17.6054 24.3705 14.9434 27.0752 11.6362 27.0752C8.28857 27.0752 5.66696 24.3705 5.66696 20.9795C5.66696 17.5885 8.28857 14.8838 11.6362 14.8838C14.9434 14.8838 17.6054 17.5885 17.6054 20.9795Z"
            fill="#171923"
          />
        </svg>
      </div>
      <div
        style="
          display: flex;
          padding: 5.334px 16.002px;
          flex-direction: column;
          align-items: center;
          gap: 6.668px;
          align-self: stretch;
        "
      >
        <p
          style="
            color: #171923;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 16.007px;
            font-style: normal;
            font-weight: 600;
            line-height: 21.336px;
          "
        >
          Unique referral code
        </p>
      </div>
      <div
        style="
          display: flex;
          padding: 5.334px 16.002px;
          justify-content: center;
          align-items: flex-start;
          gap: 6.668px;
          align-self: stretch;
        "
      >
        <p
          style="
            color: #4a5568;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 12.002px;
            font-style: normal;
            font-weight: 500;
            line-height: 18.669px;
            flex: 1 0 0;
          "
        >
         ${
           courseTitle
             ? `You have been referred to&nbsp;
          <span
            style="
              color: #4a5568;
              font-family: 'Inter', sans-serif;
              font-size: 12.002px;
              font-style: normal;
              font-weight: 700;
              line-height: 18.669px;
            "
          >
            ${courseTitle}
          </span>
          <br />
          <br />`
             : ''
         }
          This will allow you to enrol to the course.<br />This code can be used only once.
        </p>
      </div>
      <div
        style="
          display: flex;
          height: 417.576px;
          padding: 13.335px 26.67px;
          flex-direction: column;
          align-items: flex-start;
          gap: 13.335px;
          flex-shrink: 0;
          align-self: stretch;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 10.668px;
            align-self: stretch;
          "
        >
          <p
            style="
              color: #171923;
              text-align: center;
              font-family: 'Inter', sans-serif;
              font-size: 14.006px;
              font-style: normal;
              font-weight: 600;
              line-height: 20.003px;
              align-self: stretch;
            "
          >
            Visit website
          </p>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 5.334px;
              align-self: stretch;
            "
          >
            <p
              style="
                color: #2d3748;
                font-family: 'Inter', sans-serif;
                font-size: 10.668px;
                font-style: normal;
                font-weight: 400;
                line-height: 16.002px;
              "
            >
              1. Open the link in a browser
            </p>
            <div
              style="
                display: flex;
                padding: 10.668px;
                justify-content: center;
                align-items: center;
                gap: 5.334px;
                align-self: stretch;
                border-radius: 5.334px;
                background: #edf2f7;
              "
            >
              <p
                style="
                  color: #171923;
                  font-family: 'Inter', sans-serif;
                  font-size: 16.002px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 21.336px;
                "
              >
                ${appUrl}/join
              </p>
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 5.334px;
              align-self: stretch;
            "
          >
            <p
              style="
                color: #2d3748;
                font-family: 'Inter', sans-serif;
                font-size: 10.668px;
                font-style: normal;
                font-weight: 400;
                line-height: 16.002px;
              "
            >
              2. Enter the code
            </p>
            <div
              style="
                display: flex;
                padding: 10.668px;
                justify-content: center;
                align-items: center;
                gap: 5.334px;
                align-self: stretch;
                border-radius: 5.334px;
                background: #edf2f7;
              "
            >
              <p
                style="
                  color: #171923;
                  font-family: 'Inter', sans-serif;
                  font-size: 20.003px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 25.337px;
                "
              >
                ${activationCode}
              </p>
            </div>
          </div>
        </div>

        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10.668px;
            align-self: stretch;
          "
        >
          <div
            style="width: 141.662px; height: 1px; background: #a0aec0"
          ></div>
          <div
            style="
              color: #4a5568;
              text-align: center;
              font-family: 'Inter', sans-serif;
              font-size: 14.006px;
              font-style: normal;
              font-weight: 600;
              line-height: 20.003px;
              width: 37px;
            "
          >
            or
          </div>
          <div
            style="width: 141.662px; height: 1px; background: #a0aec0"
          ></div>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10.668px;
            align-self: stretch;
          "
        >
          <p
            style="
              color: #171923;
              text-align: center;
              font-family: 'Inter', sans-serif;
              font-size: 14.006px;
              font-style: normal;
              font-weight: 600;
              line-height: 20.003px;
              align-self: stretch;
            "
          >
            Scan QR code
          </p>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 5.334px;
              align-self: stretch;
            "
          >
            <p
              style="
                color: #2d3748;
                text-align: center;
                font-family: 'Inter', sans-serif;
                font-size: 10.668px;
                font-style: normal;
                font-weight: 400;
                line-height: 16.002px;
                align-self: stretch;
              "
            >
              To scan, use your camera app or QR code scanner on your device
            </p>
          </div>
          <div
            style="
              display: flex;
              padding: 13.335px;
              align-items: center;
              gap: 6.668px;
              border-radius: 10.668px;
              background: #fff;
            "
          >
            ${pngImage ? `<div><img src="${pngImage}" alt="QR Code" /></div>` : ''}
          </div>
        </div>
      </div>
    </div>
  </body>
</html>
`;
}
